import { Dispatch, SetStateAction, useContext } from "react";
import { useTranslation } from "react-i18next";
import { ArrayItemsNavBar, VisibilityMode } from "../../../types";
import { VisibilityModeCtx } from "../../../contexts/visibilityModeCtx";
import { scrollToSection } from "../../../../../utils";

export default function NavItems({setIsActiveHamburgerButton}: {setIsActiveHamburgerButton: Dispatch<SetStateAction<boolean>>}) {

	const { visibilityMode } = useContext(VisibilityModeCtx);
	const { t } = useTranslation();

	const rawItems = t("footerSection.columns.0.items", { returnObjects: true });
	const arrayItemsNavBar: ArrayItemsNavBar[] = Array.isArray(rawItems) ? rawItems : [];

	/* const [activeNavBarItem, setActiveNavBarItem] = useState<ArrayItemsNavBar>(
		Array.isArray(arrayItemsNavBar) && arrayItemsNavBar.length > 0
			? arrayItemsNavBar[0]
			: { name: "", link: "" }
	); */

	/* const scrollToSection = (id: string) => {
		document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
	}; */

	return (
		<ul
			className={`
                    flex flex-col md:flex-row gap-5 md:gap-10 2xl:gap-[4vw] justify-center items-start md:items-center
					font-[700]
					md:min-h-[24px]
            `}
		>
			{arrayItemsNavBar.length > 0 &&
				arrayItemsNavBar.map((item) => (
					<li key={item.name}>
						<button
							className={`
							relative uppercase 
							${visibilityMode !== VisibilityMode.Normal 
								? `md:[text-shadow:0px_0px_3px_rgb(255_255_255)] lg:[text-shadow:0px_0px_6px_rgb(255_255_255)] 2xl:[text-shadow:0px_0px_0.4vw_rgb(255_255_255)]`
								: ""
							}
							flex flex-row
							cursor-pointer whitespace-nowrap hover:text-[#493e22] active:text-[#493e22]
							transition-colors ease-in duration-300
                        `}
							onClick={() => {
								//setActiveNavBarItem(item);
								/* window.location.hash = item.link; */
								scrollToSection(item.link);
								setIsActiveHamburgerButton(false);
							}}
						>
							{item.name}

							{/* //Little point under the active item */}
							{/* {activeNavBarItem.link === item.link && (
								<span className="hidden md:flex absolute left-1/2 -bottom-2 2xl:-bottom-[1.2vw] w-2 2xl:w-[0.8vw] h-2 2xl:h-[0.8vw] bg-[#FFB800] rounded-full transform -translate-x-1/2 shadow" />
							)} */}
						</button>
					</li>
				))}
		</ul>
	);
}